import React, { useState, useEffect } from 'react';
import { useRouteContext } from '../../context/RouteContext';
import ReturnWizard from '../../components/returns/ReturnWizard';
import { ReturnStates } from '../../components/returns/ReturnStates';
import OrderLookup from '../../components/shared/OrderLookup';
import { useTheme } from '../../context/PortalThemeContext';
import { useMockStep } from '../../hooks/useMockStep';
import mockOrderData from '../../mock/mockOrderData.json';

export default function ReturnsPage() {
  const {
    customer,
    setCustomer,
    orderDetails,
    setOrderDetails,
    trackingInfo,
    setTrackingInfo,
    shopifyProducts,
    setShopifyProducts,
  } = useRouteContext();

  const [returnStep, setReturnStep] = useState(ReturnStates.ORDER_SUMMARY);
  const theme = useTheme();
  const mockStep = useMockStep();
  const isOrderLookup = !orderDetails || !customer;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlOrderNumber = urlParams.get('orderNumber');
    const urlEmail = urlParams.get('email');
    const autoSearch = urlParams.get('autoSearch') === 'true';

    if (urlOrderNumber && urlEmail && autoSearch) {
      setOrderDetails(null);
      setCustomer(null);
      setTrackingInfo(null);
      setShopifyProducts(null);
      return;
    }

    const local = localStorage.getItem('brella_order');
    if (local) {
      const parsed = JSON.parse(local);

      if (parsed) {
        setOrderDetails(parsed);
        if (parsed.customer) setCustomer(parsed.customer);
        if (parsed.trackingInfo) setTrackingInfo(parsed.trackingInfo);
        if (parsed.shopifyProducts) setShopifyProducts(parsed.shopifyProducts);
      }
    }
  }, []);

  useEffect(() => {
    if (!mockStep) return;

    if (mockStep !== 'ORDER_LOOKUP') {
      const mockOrder = {
        ...mockOrderData,
        claimId: '',
      };

      setOrderDetails(mockOrder);
      setCustomer(mockOrder.customer);
      setTrackingInfo(mockOrder.trackingInfo);
      setShopifyProducts(mockOrder.shopifyProducts);

      if (Object.values(ReturnStates).includes(mockStep)) {
        setReturnStep(mockStep);
      }
    } else {
      setOrderDetails(null);
      setCustomer(null);
      setTrackingInfo(null);
      setShopifyProducts(null);
      setReturnStep(ReturnStates.ORDER_SUMMARY);
    }
  }, [mockStep]);

  return (
    <div className="d-flex-column justify-content-center align-items-center returns-page w-100 py-4 px-3 px-sm-4"
    style={{ minHeight: '100vh', backgroundColor: isOrderLookup ? undefined : theme.backgroundColor }}
    >
      <div>
        {isOrderLookup ? (
          <OrderLookup
            onOrderFound={setOrderDetails}
            onCustomerFound={setCustomer}
            onTrackingInfoFound={setTrackingInfo}
            onProductDetailsFound={setShopifyProducts}
            flowType="RETURN"
          />
        ) : (
          <ReturnWizard
            initialOrderDetails={orderDetails}
            customer={customer}
            trackingInfo={trackingInfo}
            step={returnStep}
            setStep={setReturnStep}
            shopifyProducts={shopifyProducts}
          />
        )}
      </div>
    </div>
  );
}
